<div class="relative">
  <div class="flex items-center justify-between mt-8 gap-3 px-10 no-print">
    <div
      class="w-[40px] h-[40px] bg-[#285CA5] rounded-full flex items-center justify-center cursor-pointer"
      (click)="goBack()"
      title="Back"
    >
      <svg
        width="14"
        height="15"
        viewBox="0 0 14 15"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M7.58893 1.16156C7.91437 1.487 7.91437 2.01463 7.58893 2.34007L3.17819 6.75081H12.833C13.2932 6.75081 13.6663 7.12391 13.6663 7.58415C13.6663 8.04438 13.2932 8.41748 12.833 8.41748H3.17819L7.58893 12.8282C7.91437 13.1537 7.91437 13.6813 7.58893 14.0067C7.26349 14.3322 6.73586 14.3322 6.41042 14.0067L0.577085 8.1734C0.251649 7.84797 0.251649 7.32033 0.577085 6.99489L6.41042 1.16156C6.73586 0.836121 7.26349 0.836121 7.58893 1.16156Z"
          fill="white"
        />
      </svg>
    </div>
    <div class="flex items-center gap-3">
      <button appearance="primary" tuiButton type="button" size="s" (click)="printInvoice()">
        Print Invoice
      </button>
    </div>
  </div>

  <section class="mx-5 lg:mx-0" id="printJS-form">
    <div class="flex flex-col mt-10 lg:mt-10 xl:mt-16 lg:mx-10 xl:mx-16">
      <div class="flex justify-between items-start">
        <div class="w-[268px] h-[84px]">
          <img
            src="/assets/logo-vertical.png"
            class="w-full h-full object-contain"
            alt="Royal Hospital Logo"
          />
        </div>
        <div class="flex flex-col items-center justify-center">
          <p class="font-semibold text-[2.25rem] text-[#00AEEF] py-1 m-0 text-center">
            ROYAL HOSPITAL
          </p>
          <p class="font-semibold text-2xl text-[#EC008C] py-2 m-0 p-0 text-center">
            HOME NURSING CARE
          </p>
          <p class="font-normal text-base text-[#212429] py-2 m-0 text-center">
            No. 62, W.A.Silva Mawatha, Wellawatta, Colombo - 06<br />
            Hot Line: 0713257499(WhatsApp), 0760656778, 0114000100
          </p>
        </div>
        <div class="w-[268px] h-[84px] md:hidden lg:hidden xl:block 2xl:block"></div>
      </div>

      <div class="w-full bg-[#D9D9D9] h-[1px] mt-8 mb-3"></div>

      <div class="flex justify-between gap-8 items-start">
        <!--
          Left column: client info. Using a grid with a fixed-width label
          column keeps all values aligned vertically no matter how long
          each label happens to be. (The previous markup hand-tuned
          space-x for every row, which is why "Test address" used to
          drift right of the other values.)
        -->
        <div class="grid grid-cols-[120px_1fr] gap-x-6 items-start">
          <p class="text-base font-medium text-[#5B5B5B] my-[5px]">
            Client Type
          </p>
          <p class="text-base font-medium text-[#353A3F] my-[5px]">Walk-in</p>

          <p class="text-base font-medium text-[#5B5B5B] my-[5px]">
            Invoice No.
          </p>
          <p class="text-base font-medium text-[#285CA5] my-[5px]">
            {{ getInvoiceNumber() }}
          </p>

          <p class="text-base font-medium text-[#5B5B5B] my-[5px]">
            Patient Name
          </p>
          <p class="text-base font-medium text-[#353A3F] my-[5px]">
            {{ record?.walkInClientName || 'Walk-in' }}
          </p>

          <ng-container *ngIf="record?.walkInContactNo">
            <p class="text-base font-medium text-[#5B5B5B] my-[5px]">
              Contact No
            </p>
            <p class="text-base font-medium text-[#353A3F] my-[5px]">
              {{ record?.walkInContactNo }}
            </p>
          </ng-container>

          <ng-container *ngIf="record?.address">
            <p class="text-base font-medium text-[#5B5B5B] my-[5px]">Address</p>
            <p class="text-base font-medium text-[#353A3F] my-[5px]">
              {{ record?.address }}
            </p>
          </ng-container>
        </div>

        <!-- Right column: dates. Same grid trick - fixed label column. -->
        <div class="grid grid-cols-[110px_auto] gap-x-6 items-start">
          <p class="text-base font-medium text-[#5B5B5B] my-[5px]">Date</p>
          <p class="text-base font-medium text-[#353A3F] my-[5px] text-right">
            {{ today | date : 'MM/dd/yyyy' }}
          </p>

          <p class="text-base font-medium text-[#5B5B5B] my-[5px]">
            Service Date
          </p>
          <p class="text-base font-medium text-[#353A3F] my-[5px] text-right">
            {{ getServiceDate() | date : 'MM/dd/yyyy' }}
          </p>
        </div>
      </div>

      <div class="w-full bg-[#D9D9D9] h-[1px] my-3"></div>

      <p class="text-base font-medium text-[#5B5B5B] mt-8">Charges</p>

      <div class="mt-2">
        <table tuiTable size="m" class="md:w-full max-w-[55rem]">
          <thead>
            <tr>
              <th tuiTh style="background-color: #285ca5; color: white">Date</th>
              <th tuiTh style="background-color: #285ca5; color: white">Nurse name</th>
              <th tuiTh style="background-color: #285ca5; color: white">Doctor name</th>
              <th tuiTh style="background-color: #285ca5; color: white">
                Description / Procedure
              </th>
              <th tuiTh style="background-color: #285ca5; color: white">Charge</th>
            </tr>
          </thead>
          <tbody tuiTbody>
            <tr *ngIf="record">
              <td tuiTd style="padding-top: 6px; padding-bottom: 6px">
                <div tuiCell="m">
                  <p class="text-[#526ED3] text-sm">
                    {{ getServiceDate() | date : 'dd MMM yyyy' }}
                  </p>
                </div>
              </td>
              <td tuiTd style="padding-top: 6px; padding-bottom: 6px">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">{{ getNurseName() }}</p>
                </div>
              </td>
              <td tuiTd style="padding-top: 6px; padding-bottom: 6px">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">{{ getDoctorName() }}</p>
                </div>
              </td>
              <td tuiTd style="padding-top: 6px; padding-bottom: 6px">
                <div tuiCell="m">
                  <p class="text-[#191C30E5] text-sm">
                    {{ getProceduresDisplay() }}
                  </p>
                </div>
              </td>
              <td tuiTd style="padding-top: 6px; padding-bottom: 6px">
                <div tuiCell="m">
                  <p class="text-[#285CA5] text-base font-bold">
                    LKR {{ getGrandTotal() | number : '1.2-2' }}
                  </p>
                </div>
              </td>
            </tr>

            <tr *ngIf="record && getPaymentBreakdown().length > 0">
              <td
                colspan="5"
                style="padding: 8px 0; background-color: #f9fafb; border-bottom: 1px solid #e5e7eb;"
              >
                <div class="px-8">
                  <div class="bg-white rounded border border-gray-200 p-2.5">
                    <p class="text-xs font-semibold text-[#6B7280] mb-2">
                      Payment Breakdown:
                    </p>
                    <div class="grid grid-cols-3 gap-2">
                      <div
                        *ngFor="let payment of getPaymentBreakdown()"
                        class="flex justify-between items-center py-1.5 px-2 bg-gray-50 rounded text-xs"
                      >
                        <span class="text-[#6B7280]">{{ payment.label }}:</span>
                        <span class="font-semibold text-[#111827] ml-2">
                          {{ payment.amount | number : '1.2-2' }}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>

            <tr *ngIf="!record && !isLoading">
              <td colspan="5" class="text-center text-gray-500 py-4">
                No walk-in record found.
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <!-- Bottom summary: left-aligned labels, uniform amount size -->
      <div class="w-full flex justify-end mt-8">
        <div
          class="w-full max-w-xl grid grid-cols-[minmax(0,1fr)_auto] gap-x-10 gap-y-2.5 items-baseline"
        >
          <p class="text-left text-base font-medium text-[#5B5B5B] my-0">
            Additional Charges (Net)
          </p>
          <p
            class="text-right text-base font-bold text-[#2a2a2a] tabular-nums whitespace-nowrap my-0"
          >
            {{ getGrandTotal() | number : '1.2-2' }} LKR
          </p>

          <p class="text-left text-base font-bold text-[#2a2a2a] my-0">
            Amount to be Paid
          </p>
          <p
            class="text-right text-base font-bold text-[#2a2a2a] tabular-nums whitespace-nowrap my-0"
          >
            {{ getGrandTotal() | number : '1.2-2' }} LKR
          </p>
        </div>
      </div>

      <div class="w-full bg-[#D9D9D9] h-[1px] my-8"></div>
      <div class="flex space-x-28">
        <div>
          <p class="text-base font-medium text-[#5B5B5B] my-[5px]">
            Account Details
          </p>
        </div>
        <div>
          <p class="text-base font-medium text-[#353A3F] my-[5px]">
            Royal Hospital Home Nursing (pvt) ltd <br />
            Commercial Bank 1000650035 <br />
            Wellawatta 02nd Branch <br />
            Swift Code CCEYLKLX
          </p>
        </div>
      </div>
    </div>
  </section>
</div>
